import { useEffect, useRef } from 'react';
export default function useRestRecovery(characterId, restState, setLongRestCount, setShortRestCount) {
  const processed = useRef({ characterId: null, state: {} });
  useEffect(() => {
    const key = `rest-seen:${characterId}`;
    if (processed.current.characterId !== characterId) {
      let saved = {};
      try { saved = JSON.parse(localStorage.getItem(key) || '{}') || {}; } catch { /* Invalid recovery cache. */ }
      processed.current = { characterId, state: saved };
    }
    if (!characterId || !restState?.revision || Number(processed.current.state.revision || 0) >= restState.revision) return;
    const previous = processed.current.state;
    processed.current.state = restState;
    if (Number(restState.longCount || 0) > Number(previous.longCount || 0)) setLongRestCount(count => count + 1);
    else if (Number(restState.shortCount || 0) > Number(previous.shortCount || 0)) setShortRestCount(count => count + 1);
    try { localStorage.setItem(key, JSON.stringify(restState)); } catch { /* Server state still works in this tab. */ }
  }, [characterId, restState?.revision, setLongRestCount, setShortRestCount]);
}
